module.exports = __webpack_public_path__ + "img/notification.a528b926.svg";